<template>
  <div class="ism-tab-body">
    <PremiumTable
      title="Members"
      subtitle="List of all members in the society"
      :headers="headers"
      :items="flats"
      :loading="loading"
      show-search
      search-placeholder="Search members..."
    >
      <template v-slot:item.profile_url="{ item }">
        <div style="padding: 6px 0;">
          <PremiumAvatar
            :image="item.profile_url ? API_BASE_URL + '/uploads/' + item.profile_url : null"
            :name="item.name"
            :size="36"
          />
        </div>
      </template>

      <template v-slot:item.house_number="{ item }">
        <span style="font-weight: 600; color: var(--text-primary);">
          <span v-if="item.flat">{{ item.flat.name }}-</span>{{ item.house_number }}
        </span>
      </template>

      <template v-slot:item.email="{ item }">
        <span style="color: var(--text-secondary);">{{ item.email ? item.email : 'N/A' }}</span>
      </template>

      <template v-slot:item.last_active_time="{ item }">
        <span style="font-size: 12.5px; color: var(--text-secondary);">
          {{ getFormattedDate(item.last_active_time) }}
        </span>
      </template>

      <template v-slot:item.actions="{ item }">
        <PremiumActionButton
          :to="'/superadmin/society/list/' + society_id + '/member/' + item.id"
          icon="mdi-eye-outline"
          label="View"
          variant="info"
        />
      </template>
    </PremiumTable>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import moment from "moment";
import PremiumTable from '../../common/PremiumTable.vue';
import PremiumActionButton from '../../common/PremiumActionButton.vue';
import PremiumAvatar from '../../common/PremiumAvatar.vue';

export default {
  name: 'SocietyMembers',
  components: { PremiumTable, PremiumActionButton, PremiumAvatar },
  props: { society_id: String },
  
  data() {
    return {
      loading: false,
      flats: [],
      imageErrors: {},
      headers: [
        { text: 'Profile',    value: 'profile_url',      width: '10%', sortable: false },
        { text: 'House No.',  value: 'house_number',     width: '18%' },
        { text: 'Name',       value: 'name',             width: '24%' },
        { text: 'Email',      value: 'email' },
        { text: 'Last Active',value: 'last_active_time', width: '20%', sortable: false },
        { text: 'Actions',    value: 'actions',          width: '8%',  sortable: false },
      ],
    }
  },

  methods: {
    ...mapMutations("alert", ["setAlert"]),

    getFormattedDate(date) {
      return date ? moment(date).format("DD MMM, YYYY hh:mm A") : "N/A";
    },

    getSocietyFlats() {
      this.loading = true;
      this.$axios.get(`society/${this.society_id}/members`).then(res => {
        this.loading = false;
        const data = res.data;
        if (data.status) {
          this.flats = data.members;
        } else {
          this.setAlert({ showAlert: true, variant: "red accent-3", timeout: 3000, message: data.message });
        }
      }).catch(() => { this.loading = false; });
    },
  },

  mounted() {
    this.getSocietyFlats();
  }
};
</script>

<style scoped>
.ism-tab-body {
  padding: 28px;
}
.ism-member-avatar {
  width: 36px; height: 36px; border-radius: 50%; overflow: hidden; border: 1px solid var(--border-color);
}
.ism-member-fallback {
  width: 36px; height: 36px; border-radius: 50%; 
  background: linear-gradient(135deg, var(--accent), var(--accent-hover)); 
  display: flex; align-items: center; justify-content: center; 
  color: #fff; font-size: 13px; font-weight: 700; font-family: 'Inter', sans-serif;
  box-shadow: 0 2px 8px var(--accent-glow);
}

@media (max-width: 600px) {
  .ism-tab-body { padding: 16px; }
}
</style>